import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "phoneNumber", standalone: false })
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return "";

    // Remove all non-digits
    const cleaned = value.replace(/\D/g, "");

    // Format as (XXX) XXX-XXXX
    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      // Remove leading 1 for US numbers
      const match = cleaned.slice(1).match(/^(\d{3})(\d{3})(\d{4})$/);
      return match ? `(${match[1]}) ${match[2]}-${match[3]}` : value;
    } else if (cleaned.length === 10) {
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      return match ? `(${match[1]}) ${match[2]}-${match[3]}` : value;
    }

    return value;
  }
}
